import React from 'react'
import Snackbar from '@mui/material/Snackbar';
import Alert from "@mui/material/Alert";
import { useSelector, useDispatch } from "react-redux";
import { closeSnackbar } from './snackbar-slice';


const AlertStatus = React.forwardRef(function Alert(props, ref) {
  return <Alert elevation={6} ref={ref} variant="filled" {...props} />;
});

const SnackbarStatus = () => { 
  const { type, open, message } = useSelector(state => state.snackbarSlice)
  const dispatch = useDispatch()
  const onCloseHandler = () => dispatch(closeSnackbar())

  return (
    <Snackbar
      id="snackbar"
      open={open}
      autoHideDuration={4000}
      onClose={onCloseHandler}
    //   anchorOrigin={{vertical: 'top', horizontal: 'center'}}
    >
      <Alert severity={ type } onClose={onCloseHandler}>
        {message}
      </Alert>
    </Snackbar>
  );
}

export default SnackbarStatus;